import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import CancelIcon from '@mui/icons-material/Cancel';

type CancelButtonProps = {
    onClick: () => void;
    color?: string;
};

const CancelButton: React.FC<CancelButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "secondary"}
            startIcon={<CancelIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_CANCEL'}/>
        </Button>
    );
};
export default CancelButton;
